module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN333_26253178.623fe93e.png";